import React, { ButtonHTMLAttributes, DetailedHTMLProps, ReactNode } from 'react'

import classNames from 'classnames'

import style from './Button.module.css'

type DefaultButtonPropsType = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>

type PropsType = DefaultButtonPropsType & {
  children: ReactNode
  className?: string
  accent?: boolean
}

export const Button = ({ children, className = '', accent = false, ...restProps }: PropsType) => {
  return (
    <button
      className={classNames(style.button, className, { [style.accent]: accent })}
      {...restProps}
    >
      {children}
    </button>
  )
}
